import React from 'react';
import { Avatar, Box, Button, styled } from '@mui/material';
import Link from 'next/link';

const ArticleSourceButton = (styled(Button)`
  padding: ${({ theme }) => theme.spacing(1.5, 2.5, 1.5, 1.5)};
` as unknown) as typeof Button;

interface IArticleSourceLink {
  sourceUrl: string;
  icon: string;
  text: string;
}

const ArticleSourceLink: React.FC<IArticleSourceLink> = ({
  icon,
  text,
  sourceUrl,
}) => {
  return (
    <Box>
      <Link href={sourceUrl} passHref>
        <ArticleSourceButton
          component="a"
          color="info"
          variant="contained"
          target="_blank"
          startIcon={
            <Avatar src={icon} sx={{ width: 30, height: 30 }}>
              {text[0]}
            </Avatar>
          }
        >
          {text} ↗
        </ArticleSourceButton>
      </Link>
    </Box>
  );
};

export default ArticleSourceLink;
